import React from 'react';
import {AsyncValueStates, ButtonType, useAsyncOperation, useObservable} from '@wix/devzai-utils-react';
import {
    DoppeActionTypeWidgetInnerButton
} from '../doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {evaluateFunction, OmitStrict, uiPartCreateMarking} from '@wix/devzai-utils-common';
import IconLock from '../doppe-action-button-templates/doppe-standard-action-button-template/icons/Lock.svg';
import {useDoppeViewerClientServices} from '../../client/doppe-user-app/doppe-viewer-client-services';
import {IDoppeViewerActionContext} from '../../doppe-sdk';
import {doppeHideableValueIsVisibleAndNotEqualValue} from '../../client-server-common';
import {
    DoppeActionTypeWidgetInnerCtaButtonParts,
    doppeActionTypeWidgetInnerCtaButtonPartsCreateName
} from './doppe-action-type-widget-inner-cta-button.ui-parts';

export const DoppeActionTypeWidgetInnerCtaButton = React.memo(function DoppeActionTypeWidgetInnerCtaButton(props: DoppeActionTypeWidgetInnerCtaButton.Props) {
    const {
        buttonType,
        actionContext,
        onClick,
        isLoading,
        children,
        tagName,
        href,
        target,

        ...htmlAttributes
    } = props;

    const clientServices = useDoppeViewerClientServices();
    const isLockedObservable = clientServices.lockService.getActionLockObservable(actionContext.action);
    const isLocked = useObservable(isLockedObservable, observable => observable?.getValue() ?? false);

    const customButtonText = actionContext.action.lockSettings.lockPreviewInnerCtaButtonText;


    const [unlockOperation, setUnlockOperation] = useAsyncOperation();

    return (
        <DoppeActionTypeWidgetInnerButton
            {...htmlAttributes}
            buttonType={isLocked ? ButtonType.NormalButton : buttonType}
            suffixIcon={isLocked ? IconLock : undefined}
            isLoading={(!isLocked && isLoading) || unlockOperation?.state === AsyncValueStates.Pending}
            href={isLocked ? undefined : href}
            tagName={isLocked ? undefined : tagName}
            target={isLocked ? undefined : target}
            onClick={isLocked ? async () => {
                await setUnlockOperation(evaluateFunction(async () => {
                    await actionContext.startUnlocking(() => {
                        isLockedObservable?.setValue(false);
                    }, false);
                }))
            } : onClick}
            children={isLocked && doppeHideableValueIsVisibleAndNotEqualValue(customButtonText, '') ? customButtonText : children}
            {...uiPartCreateMarking(DoppeActionTypeWidgetInnerCtaButtonParts.Root, doppeActionTypeWidgetInnerCtaButtonPartsCreateName(actionContext.action.id))}
        />
    );
});

export namespace DoppeActionTypeWidgetInnerCtaButton {

    export interface Props extends OmitStrict<DoppeActionTypeWidgetInnerButton.Props, 'suffixIcon'> {
        actionContext: IDoppeViewerActionContext;
    }

}
